module.exports = __webpack_public_path__ + "img/24.68283a47.jpg";